<template>
  <section id="partners" class="py-5 light-section">
    <div class="container text-center">
      <h2 class="mb-5">Unsere Partner</h2>
      <div class="row justify-content-center partner-container">
        <div
            class="card col-md-3 slide-in-card"
            :class="{ 'slide-in-card-active': partnerCardsVisible }"
            v-for="partner in partners"
            :key="partner.id"
        >
          <div class="card-body d-flex flex-column">
            <img :src="partner.logo" :alt="`Logo von ${partner.name}`" class="img-fluid partner-logo"/>
            <div class="partner-name">{{ partner.name }}</div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import {defineComponent, ref, onMounted} from 'vue';

export default defineComponent({
  setup() {
    const partners = ref([
      {id: 1, name: 'Bergische Universität Wuppertal', logo: require('@/assets/partner/buw.png')},
      {
        id: 2,
        name: 'Institute for Technologies and Management of Digital Transformation',
        logo: require('@/assets/partner/tmdt.webp')
      },
      {
        id: 3,
        name: 'Interdisziplinäres Zentrum für maschinelles Lernen und Datenanalyse',
        logo: require('@/assets/partner/izmd.webp')
      },
      {id: 4, name: 'Mittelstand-Digital Zentrum Handwerk', logo: require('@/assets/partner/mhd.png')},
      {id: 5, name: 'Kreishandwerkerschaft Rhein-Erft', logo: require('@/assets/partner/khre.png')},
      {
        id: 6,
        name: 'Bundesverband Garten- Landschafts- und Sportplatzbau',
        logo: require('@/assets/partner/galabau.jpg')
      }
    ]);

    const partnerCardsVisible = ref(false);

    onMounted(() => {
      const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                partnerCardsVisible.value = true;
                observer.disconnect(); // Stop observing after first appearance
              }
            });
          },
          {threshold: 0.1}
      );

      const partnersSection = document.querySelector('#partners .row');
      if (partnersSection) observer.observe(partnersSection);
    });

    return {partners, partnerCardsVisible};
  },
});
</script>

<style scoped lang="less">
@import '@/assets/style.less';

.partner-container {
  gap: 1.5rem;
}

.partner-logo {
  width: 150px; /* Feste Breite */
  height: 100px; /* Feste Höhe */
  object-fit: contain; /* Logos bleiben proportional */
  filter: grayscale(100%);
  transition: filter 0.3s ease;
  margin-bottom: 10px;
}

.card:hover .partner-logo {
  filter: grayscale(0%);
}

.partner-name {
  font-weight: bold;
  flex-grow: 1;
}

@media (max-width: 768px) {
  .partner-logo {
    filter: grayscale(0%);
    width: 100px;
    height: 75px;
    margin-bottom: 5px;
  }

  .card-body {
    flex-grow: 0;
    padding: 5px;
    flex-direction: row !important;
    gap: 10px;
  }

  .partner-container {
    gap: .5rem;
  }

  .partner-name {
    font-size: 0.7rem;
  }

}

</style>
